import React from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";

function Input(props: any) {
  const { label, name, ...rest } = props;
  return (
    // <div className="form-control">
    //   <label htmlFor={name}>{label}</label>
    //   <Field id={name} name={name} {...rest} />
    //   <ErrorMessage component={TextError} name={name} />
    // </div>

    <div className="form-group">
      <label htmlFor={name} className="mb-1 form-label">
        {label}
      </label>
      <Field id={name} name={name} {...rest} />
      <ErrorMessage component={TextError} name={name} />

      {/* <input
                                type="password"
                                className="form-control form-control-sm"
                                name="old-password"
                                placeholder="Enter password"
                              /> */}
    </div>
  );
}

export default Input;
